// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1RxbO"};